// =============================
// Config
// =============================

// IE is handled by NextJS now https://nextjs.org/docs/basic-features/supported-browsers-features
// const isIE = () => /(msie|trident)/i.test(navigator.userAgent);
// const isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

require('intersection-observer');
